import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-fiyatlari-2026/page.tsx");
